/**
 * viewportFix.js
 * 
 * This utility fixes the viewport height issue on mobile browsers,
 * particularly for devices like the Pixel 7 where 100vh includes
 * the address bar area, causing content to be cut off.
 */

// Function to set a CSS variable with the actual viewport height
const setViewportHeight = () => {
  // Get the actual viewport height
  const vh = window.innerHeight * 0.01;
  
  // Set the CSS variable
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

// Initialize on load
const initViewportFix = () => {
  // Set the height initially
  setViewportHeight();
  
  // Update on resize and orientation change
  window.addEventListener('resize', setViewportHeight);
  window.addEventListener('orientationchange', setViewportHeight);
};

export default initViewportFix;